(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/dialog-contextual/assets/javascripts/dialog-contextual.js') >= 0) return;  svs.modules.push('/components/tipsen/dialog-contextual/assets/javascripts/dialog-contextual.js');
"use strict";

const _svs$ui = svs.ui,
  ReactIcon = _svs$ui.ReactIcon,
  ReactIconButton = _svs$ui.ReactIconButton;
const _svs$components$dialo = svs.components.dialog,
  Contextual = _svs$components$dialo.Contextual,
  TEXT = _svs$components$dialo.TEXT;

const DialogContextual = _ref => {
  let children = _ref.children,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'fc-sport' : _ref$color,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  const showDialog = event => {
    svs.components.dialog.api.add(new Contextual({
      area: svs.components.dialog.area.CONTEXTUAL,
      branding: svs.components.dialog.branding.SPORT,
      attachTo: event.currentTarget,
      title: '',
      message: [{
        type: TEXT,
        text: children
      }]
    }));
  };
  return React.createElement(ReactIconButton, {
    className: className,
    onClick: e => showDialog(e)
  }, React.createElement(ReactIcon, {
    color: color,
    icon: "help"
  }));
};
setGlobal('svs.components.tipsen.DialogContextual', DialogContextual);

 })(window);